import { render, staticRenderFns } from "./CustomWinwheel.vue?vue&type=template&id=086b7972&"
import script from "./CustomWinwheel.vue?vue&type=script&lang=js&"
export * from "./CustomWinwheel.vue?vue&type=script&lang=js&"
import style0 from "./CustomWinwheel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports